import AppState from '@/js/AppState';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import classes from './HaxeBackend.module.css';
import { observer } from 'mobx-react-lite';



const HaxeBackend = ({visible}) => {


  const elementRef = useRef(null)

  useEffect(() => {
    if (visible) {
      if (AppState.haxeCanvas.parentElement)
        AppState.haxeCanvas.parentElement.removeChild(AppState.haxeCanvas)
      elementRef.current.append(AppState.haxeCanvas)
    }
  }, [visible]);




  return (
    <>
      <div className={clsx(classes.HaxeBackend, visible && classes.visible)} ref={elementRef} />

    </>
  );
};

export default observer(HaxeBackend)
